export default function (table) {
  const $groupCheck = table.find('tr.level_0 .export-attachment input')
  const $allAttachmentInputsInGroup = table.find(
    'tr.level_1 .export-attachment input'
  )
  const $checkedAttachmentInputsInGroup = table.find(
    'tr.level_1 .export-attachment input:checked'
  )

  return $groupCheck.prop(
    'checked',
    $allAttachmentInputsInGroup.length ===
      $checkedAttachmentInputsInGroup.length
  )
}
